import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import {
    ComponentThatCanDisableOptions,
    ComponentWithOptions,
    InputComponent,
} from "components/components/Component";
import { LabelElement } from "components/components/label/labelElement";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { Optgroup, Option } from "components/input/select/options";
import template from "./selectMultiple.hbs";
import { SelectMultipleInputElement, initSelectMultipleInputWebComponent } from "./selectMultipleElement";

initSelectMultipleInputWebComponent();

export class SelectMultipleInput extends SimpleInputBaseComponent<SelectMultipleInputDefinition> implements InputComponent, ComponentWithOptions, ComponentThatCanDisableOptions {

    public readonly componentType: string = "selectMultipleInput";

    private element: SelectMultipleInputElement;
    private definitionOptions: Array<Option | Optgroup> = [];

    constructor(schema: SelectMultipleInputDefinition) {
        super(schema);
        if (this.definition.options != null) {
            this.definitionOptions = this.definition.options;
        }
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();

        //Por si vienen definiciones en bundle
        this.addDefinitionOptions();

        ComponentActionHelper.register(this);
        return this.view;
    }

    private addDefinitionOptions() {
        if (this.definitionOptions != null && this.definitionOptions.length > 0) {
            this.element.setOptions(this.definitionOptions);
        }
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-select-multiple-input");

        this.genericBindEvents(this.element, false);

    }

    public getValue(): string[] {
        return this.element.data;
    }

    public value(v: string[]) {
        if ((v == null) || (!Array.isArray(v)) || (Array.isArray(v) && v.length == 0)) {
            this.element.data = null;
        } else {
            this.element.data = v;
        }
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }

    public addOptions(options: Array<Option | Optgroup>): void {
        this.element.addOptions(options);
    }

    public setOptions(options: Array<Option | Optgroup>): void {
        this.element.setOptions(options);
    }

    public enableOptions(options: Array<string | number>) {
        this.element.enableOptions(options);
    }

    public disableOptions(options: Array<string | number>) {
        this.element.disableOptions(options);
    }
}

export interface SelectMultipleInputDefinition extends SimpleInputBaseDefinition {
    codeInOptionLabel?: boolean;
    options?: Array<Option | Optgroup>;
}
